import styled from "@emotion/styled"
import Dialog from "@mui/material/Dialog"

const StyledProgramCategoryDialog = styled(Dialog)`
  .MuiPaper-root {
    width: min(900px, calc(100vw - 30px));
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 24px 52px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 18px 24px 8px;
  }

  .dialog-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 6px 0 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .MuiDialogContent-root {
    padding: 10px 20px 12px;
  }

  .category-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 12px;
    margin-top: 4px;
  }

  .category-section {
    border: 1px solid var(--cms-border);
    border-radius: 14px;
    background: var(--cms-surface-muted);
    padding: 12px;
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);
  }

  .category-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
  }

  .category-name {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: var(--cms-text-primary);
  }

  .subcategory-count {
    font-size: 11px;
    font-weight: 700;
    color: var(--cms-text-secondary);
    border: 1px solid var(--cms-border);
    border-radius: 999px;
    padding: 3px 8px;
    background: var(--cms-surface-secondary);
  }

  .subcategory-section {
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: 230px;
    overflow: auto;
    padding-right: 4px;
  }

  .subcategory-empty {
    margin: 0;
    font-size: 12px;
    color: var(--cms-text-secondary);
  }

  .MuiFormControlLabel-root {
    margin: 0;
    padding: 3px 0;
    border-radius: 8px;
  }

  .MuiFormControlLabel-label {
    font-size: 13px;
    color: var(--cms-text-primary);
  }

  .MuiCheckbox-root {
    padding: 6px 8px 6px 0;
  }

  .MuiDialogActions-root {
    padding: 12px 22px 20px;
    gap: 10px;
  }

  .dialog-close-btn {
    text-transform: none;
    font-weight: 700;
    color: var(--cms-text-secondary);
  }

  .dialog-submit-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(29, 78, 216, 0.22);
  }
`

export { StyledProgramCategoryDialog }
